import script from "./ScrollHint.vue?vue&type=script&setup=true&lang=ts"
export * from "./ScrollHint.vue?vue&type=script&setup=true&lang=ts"

import "./ScrollHint.vue?vue&type=style&index=0&id=229d5937&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229d5937"]])

export default __exports__